import { countryToAlpha2 } from "country-to-iso"
import * as Flags from 'country-flag-icons/react/3x2'

const { Switch } = require("@mui/material")

const IconComponent=(props)=> {
  let field = props.colDef.field; 
  let value = props.data?.[field];
    return <Switch size="small" defaultChecked={value} disabled />
}

export const CountryIconComponent = (props) => {
    let code = countryToAlpha2(props.value)
    const Flag = Flags[code?.toUpperCase()];
    return <span style={{ display: "flex" }}> {code && <Flag width={18} style={{ marginInline: "5px" }} />} <p>{props.value}</p></span>
}

export default IconComponent
